import { toLower } from 'lodash/fp';
import { useEffect, useRef } from 'react';
import { Stack } from '@optimus-web/core';

interface ModalManagerDialogEventHandlerProps {
    children: React.ReactNode;
    onPostFormSubmit: ({ url, data }: { url: string; data: FormData }) => void;
}

export const ModalManagerDialogEventHandler = ({ onPostFormSubmit, children }: ModalManagerDialogEventHandlerProps) => {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleFormSubmit = (e: Event) => {
            const { target: form } = e;
            if (!form || !isHTMLFormElement(form)) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            const formData = new FormData(form);
            const method = form.getAttribute('method') || 'post';
            const action = form.getAttribute('action') || '';
            if (toLower(method) === 'post') {
                if (form.getAttribute('submitted') === 'true') {
                    return;
                }
                form.setAttribute('submitted', 'true');
                onPostFormSubmit({ url: action, data: formData });
            }
        };
        let element: HTMLDivElement;
        if (ref.current) {
            element = ref.current;
            ref.current.addEventListener('submit', handleFormSubmit);
        }

        return () => {
            if (element) {
                element.removeEventListener('submit', handleFormSubmit);
            }
        };
    }, [onPostFormSubmit]);

    return (
        <Stack fill vertical spacing="0" ref={ref}>
            {children}
        </Stack>
    );
};

const isHTMLFormElement = (element: EventTarget): element is HTMLFormElement =>
    (element as HTMLFormElement).submit !== undefined;
